export function RoutePending() {
  return (
    <div className="relative flex h-full w-full flex-col items-center">
      <div className="bg-primary/20 absolute inset-x-0 top-0 h-0.5 overflow-hidden">
        <div className="bg-primary h-full w-1/4 animate-[indeterminate_1.5s_ease-in-out_infinite]" />
      </div>
    </div>
  )
}
